import React from 'react';
import { WorkflowLayout } from 'Organisms/WorkflowLayout';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { IdentityVerificationButton } from 'Views/Authentication/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ContactSupportButton } from 'Views/Authentication/Components/ContactSupportButton';

export const AuthnMfaResetVerificationLayout = () => {
  return (
    <WorkflowLayout appearance={'elevated'} alwaysShowFacetLogo>
      <FDContentContainer maxWidth="sm">
        <FDStack direction={'column'} spacing={4} alignItems={'center'}>
          <FDStack direction={'column'} spacing={2} alignItems={'center'}>
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'description'} />
            <MetaControlField attr={'message'} />
          </FDStack>
          <IdentityVerificationButton />
          <ContactSupportButton />
        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};
